<template>
    <v-layout justify-center>
        <div class="mark-new-request">
            <span style="color: #B2B4C6">{{ formatDateTime(message.created_time) }}</span><br/>
            <span v-if="message.type === MESSAGE_TYPE.MAD_NEW_REQUEST">
                {{ $t('agent') | capitalize }} {{ assignor_name }}: {{ $t('createNewRequestHumanSupport') }}
                <br/>
            </span>
            <span v-else-if="message_text">
                <span class="text-pre">{{ $t(message_text, message_text_params) }}</span>
                <br/>
            </span>
            <span v-if="message.type === MESSAGE_TYPE.AUTO_MARK_REQUEST_SUPPORT_AS_DONE && user_name">
                {{ $t('agent') | capitalize }}: {{ user_name }}
                <br/>
            </span>
            <span v-if="skill_name && show_skill_name_line">
                {{ $t('requestSupportSkill') | capitalize }}: {{ skill_name }}
                <br/>
            </span>
            <span v-if="content.request_comment">
                <span class="text-pre">{{ $t('requestContent') | capitalize }}: {{ content.request_comment }}</span>
                <br/>
            </span>
            <span v-if="content.description">
                <span class="text-pre">{{ $t('requestDescription') | capitalize }}: {{ content.description }}</span>
                <br/>
            </span>
            <span v-if="content.reason">
                <span class="text-pre">{{ $t('reason') | capitalize }}: {{ content.reason }}</span>
                <br/>
            </span>
            <span v-if="content.notes">
                <span class="text-pre">{{ $t('sessionNotes') | capitalize }}: {{ content.notes }}</span>
                <br/>
            </span>
            <span v-if="content.topic">
                <span class="text-pre">{{ $t('topic') | capitalize }}: {{ content.topic }}</span>
                <br/>
            </span>
            <span v-if="content.mark_as_important">
                <span class="text-pre">{{ $t('systemNote.markAsImportant') | capitalize }}</span>
                <br/>
            </span>
            <span v-if="content.summary_text">
                <span class="text-pre">{{ content.summary_text }}</span>
                <br/>
            </span>
        </div>
    </v-layout>
</template>
<script>
import moment from "moment";

export default {
    name: "SystemMessage",
    props: {
        message: Object
    },
    data() {
        return {
            content: typeof this.message.content === 'string' ? JSON.parse(this.message.content) : this.message.content,
            MESSAGE_TYPE: {
                MAD_NEW_REQUEST: "mad_new_request",
                SENDER_REQUEST_SUPPORT: "sender_request_support",
                FORWARD_REQUEST_SUPPORT: "forward_request_support",
                FORWARD_REQUEST_SUPPORT_BY_SKILL: "forward_request_support_by_skill",
                ASSIGN_REQUEST_SUPPORT: "assign_request_support",
                ASSIGN_REQUEST_SUPPORT_BY_SKILL: "assign_request_support_by_skill",
                AUTO_ASSIGN_REQUEST_SUPPORT: "auto_assign_request_support",
                MARK_REQUEST_SUPPORT_AS_DONE: "mark_request_support_as_done",
                AUTO_MARK_REQUEST_SUPPORT_AS_DONE: "auto_mark_request_support_as_done",
                BLOCK_SENDER: "block_sender",
                SENDER_UPDATE_UNFOLLOW_STATUS: "sender_update_unfollow_status",
                CHANGE_REQUEST_SUPPORT: "change_request_support",
                SUMMARY_CONVERSATION: "summary_conversation",
            },
            message_text: "",
            message_text_params: [],
            assignor_name: "",
            user_name: "",
            skill_name: "",
            old_skill_name: "",
            new_skill_name: "",
            show_skill_name_line: true,
        }
    },
    mounted() {
        try {
            if (this.content.assignor) {
                this.assignor_name = this.get_staff_name(this.content.assignor);
            }
            if (this.content.user) {
                this.user_name = this.get_staff_name(this.content.user);
            }
            if (this.content.request_support_categories && this.content.request_support_categories.length > 0) {
                this.skill_name = this.get_skill_name(this.content.request_support_categories)
            }
            if (this.content.old_request_support_categories) {
              if (this.content.old_request_support_categories.length > 0) {
                this.old_skill_name = `"${this.get_skill_name(this.content.old_request_support_categories)}"` || this.$t("noSkill")
              } else {
                this.old_skill_name = this.$t("noSkill")
              }
            }
            if (this.content.new_request_support_categories) {
              if (this.content.new_request_support_categories.length > 0) {
                this.new_skill_name = `"${this.get_skill_name(this.content.new_request_support_categories)}"` || this.$t("noSkill")
              } else {
                this.new_skill_name = this.$t("noSkill")
              }
            }

            switch (this.message.type) {
                case this.MESSAGE_TYPE.MAD_NEW_REQUEST:
                    break;
                case this.MESSAGE_TYPE.SENDER_REQUEST_SUPPORT:
                    this.message_text = 'userSendRequestHumanSupport';
                    break;
                case this.MESSAGE_TYPE.FORWARD_REQUEST_SUPPORT:
                    this.message_text = 'systemNote.forwardRequestSupport';
                    this.message_text_params = [this.assignor_name, this.user_name];
                    this.show_skill_name_line = false;
                    break;
                case this.MESSAGE_TYPE.FORWARD_REQUEST_SUPPORT_BY_SKILL:
                    this.message_text = 'systemNote.forwardRequestSupportBySkill';
                    this.message_text_params = [this.assignor_name, this.skill_name, this.user_name];
                    this.show_skill_name_line = false;
                    break;
                case this.MESSAGE_TYPE.ASSIGN_REQUEST_SUPPORT:
                    if (this.content.assignor.id !== this.content.user.id) {
                        this.message_text = 'systemNote.assignRequestSupport';
                        this.message_text_params = [this.assignor_name, this.user_name];
                        this.show_skill_name_line = false;
                    } else {
                        this.message_text = 'systemNote.assignRequestSupportToSelf';
                        this.message_text_params = [this.user_name];
                        this.show_skill_name_line = false;
                    }
                    break;
                case this.MESSAGE_TYPE.ASSIGN_REQUEST_SUPPORT_BY_SKILL:
                    this.message_text = 'systemNote.assignRequestSupportBySkill';
                    this.message_text_params = [this.assignor_name, this.skill_name, this.user_name];
                    this.show_skill_name_line = false;
                    break;
                case this.MESSAGE_TYPE.AUTO_ASSIGN_REQUEST_SUPPORT:
                    this.message_text = 'systemNote.autoAssignRequestSupport';
                    this.message_text_params = [this.user_name];
                    break;
                case this.MESSAGE_TYPE.MARK_REQUEST_SUPPORT_AS_DONE:
                    this.message_text = 'systemNote.markRequestAsDone';
                    this.message_text_params = [this.user_name];
                    break;
                case this.MESSAGE_TYPE.AUTO_MARK_REQUEST_SUPPORT_AS_DONE:
                    this.message_text = 'systemNote.autoMarkRequestAsDone';
                    break;
                case this.MESSAGE_TYPE.BLOCK_SENDER:
                    if (this.content.block_status === true) {
                        this.message_text = 'systemNote.blockCustomer';
                    } else {
                        this.message_text = 'systemNote.unblockCustomer';
                    }
                    this.message_text_params = [this.user_name];
                    break;
                case this.MESSAGE_TYPE.SENDER_UPDATE_UNFOLLOW_STATUS:
                    if (this.content.unfollow_status === true) {
                        this.message_text = 'systemNote.customerUnfollow';
                    } else {
                        this.message_text = 'systemNote.customerFollow';
                    }
                    break;
                case this.MESSAGE_TYPE.CHANGE_REQUEST_SUPPORT:
                    this.message_text = 'systemNote.changeRequestSupport';
                    this.message_text_params = [this.assignor_name, this.old_skill_name, this.new_skill_name,];
                    this.show_skill_name_line = false;
                    break;
                case this.MESSAGE_TYPE.SUMMARY_CONVERSATION:
                    this.message_text = 'systemNote.summaryContent';
                    this.message_text_params = {};
                    break;
                default:
                    console.error(`invalid system note.` + JSON.stringify(this.message))
            }
        } catch (e) {
            console.error(e)
        }
    },
    watch: {
      '$i18n.locale': {
        handler(val) {
          if (this.message.type === this.MESSAGE_TYPE.CHANGE_REQUEST_SUPPORT) {
            if (this.content.old_request_support_categories && this.content.old_request_support_categories.length === 0) {
              this.old_skill_name = this.$t("noSkill")
            }
            if (this.content.new_request_support_categories && this.content.new_request_support_categories.length === 0) {
              this.new_skill_name = this.$t("noSkill")
            }
            this.message_text_params = [this.assignor_name, this.old_skill_name, this.new_skill_name,];
          }
        }
      },
    },
    methods: {
        timeFormat(time) {
            return moment(time).format('HH:mm')
        },
        get_staff_name(staff) {
            return staff && staff.name ? staff.name : staff.email;
        },
        get_skill_name(request_support_categories) {
            let names = []
            for (let skill of request_support_categories) {
                names.push(skill.name);
            }
            return names.join(", ");
        },
        formatDateTime(value) {
            if (!value) return '';
            return moment.utc((value)).local().format('DD-MM-YYYY HH:mm')
        },
    }
};
</script>
<style lang="scss" scoped src="../../style/chat-view.scss"></style>
<style scoped>
.text-pre {
  white-space: pre-line;
  word-break: break-word;
  align-items: center;
}
</style>
